export default __webpack_public_path__ + "f6a0838b6690eaaa2898083eaa3431c1.ttf";